<script lang="ts">
  import Pencil from "~icons/ph/pencil";

  let {
    label,
    value,
    onclick,
    hasChanged,
    isInvalid
  }: {
    label: string;
    value: string | string[];
    onclick: () => void;
    hasChanged: boolean;
    isInvalid: boolean;
  } = $props();

  const lines = [value].flat();
  const hasValue = lines.length > 0 && lines.some(Boolean);
</script>

<div class="flex justify-between items-start gap-2 py-4 border-t border-neutral-200">
  <div class="grow shrink min-w-0">
    <div class="font-medium mb-1">{label}</div>
    <div class="flex gap-1 max-w-full">
      {#if hasChanged}
        <div class="mt-[0.44rem] h-[0.625rem] w-[0.625rem] bg-emerald-500 rounded-full shrink-0"></div>
      {/if}
      <div class="text-gray-500 max-w-full">
        {#if !hasValue}
          <div class="text-gray-400">None</div>
        {:else}
          {#each lines as line}
            <div class:text-error={isInvalid} class="wrap-anywhere w-full overflow-hidden [line-break:anywhere]">{line}</div>
          {/each}
        {/if}
        {#if isInvalid}
          <div class="ui-error mt-0">Please provide a valid {label.toLowerCase()}</div>
        {/if}
      </div>
    </div>
  </div>
  <button
    type="button"
    class="h-11 w-11 shrink-0 rounded-full flex justify-center items-center {isInvalid ?  "bg-blue-600 text-white" : "text-blue-950 bg-gray-200"}"
    {onclick}
  >
    <span class="sr-only">Edit</span>
    <Pencil class="h-6 w-6" />
  </button>
</div>
